import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-beachtennis-ranking-classif',
  templateUrl: './beachtennis-ranking-classif.component.html',
  styleUrls: ['./beachtennis-ranking-classif.component.scss']
})
export class BeachtennisRankingClassifComponent implements OnInit {
    /**
     * Definição para receber o identificador do ranking
     */
    rankingId: string;

    constructor(private route: ActivatedRoute) {}

    ngOnInit(): void {
        this.rankingId = this.route.snapshot.paramMap.get('rankingId');
    }
}
